export default "__VITE_ASSET__f82cdaaf__"